import React, { useState, useEffect } from "react";
import "./logoPage.css";
import android from "../picture/Android.png";
import apple from "../picture/Apple.png";
import logo from "../picture/Logo.png";
import youtube from "../picture/Youtube.png";
import rectangularPlay from "../picture/rectangular-play.png";
import www from "../picture/Www.png";
import { useGlobalContext } from "../Context/Context";

const LogoPage = ({ setCurrentPage }) => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallVisible, setIsInstallVisible] = useState(false);
  const {
    isAndroid,
    setIsAndroid,
    isIOS,
    setIsIOS,
    isFromHome,
    setLoggedUser,
  } = useGlobalContext();

  useEffect(() => {
    const interval = setTimeout(() => {
      handleSetCurrentPage();
    }, 4000);

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsInstallVisible(true); // Show install buttons
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    // Detect if the app is installed (for PWA on mobile)
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone;

    if (!isStandalone) {
      // Detect the user's device
      const userAgent = window.navigator.userAgent.toLowerCase();
      if (/android/.test(userAgent)) {
        setIsAndroid(true);
        setIsIOS(false); // Ensure only one is true
      } else if (/iphone|ipad|ipod/.test(userAgent)) {
        setIsIOS(true);
        setIsAndroid(false); // Ensure only one is true
      }
    } else {
      // Hide the install buttons if app is already installed
      setIsInstallVisible(false);
    }

    return () => {
      clearTimeout(interval);
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, [setCurrentPage]);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const choiceResult = await deferredPrompt.userChoice;
    if (choiceResult.outcome === "accepted") {
      console.log("User accepted the install prompt");
    } else {
      console.log("User dismissed the install prompt");
    }
    setDeferredPrompt(null);
    setIsInstallVisible(false); // Hide buttons after installation
  };

  const handleSetCurrentPage = () => {
    if (isFromHome) {
      setCurrentPage(4);
      setLoggedUser(JSON.parse(localStorage.getItem("editor-user")));
    } else {
      setCurrentPage(1);
    }
  };

  return (
    <>
      <div
        className="wrapper-logo"
        style={
          !isInstallVisible
            ? { justifyContent: "flex-end", paddingBottom: "10%" }
            : { justifyContent: "center" }
        }
      >
        {isInstallVisible && (
          <div className="android-apple">
            <img
              src={apple}
              alt="Install on iOS"
              onClick={isIOS ? handleInstallClick : null}
              className={isIOS ? "glow" : ""}
            />
            <img
              src={android}
              alt="Install on Android"
              onClick={isAndroid ? handleInstallClick : null}
              className={isAndroid ? "glow" : ""}
            />
          </div>
        )}
        <div
          className="logo"
          onClick={() => handleSetCurrentPage()}
          onTouchStart={() => handleSetCurrentPage()}
        >
          <img src={logo} alt="Logo" style={{ marginBottom: "5vh" }} />
        </div>
        <div className="youtube-link">
          <img src={rectangularPlay} alt="Rectangle Youtube" />
          <img src={www} alt="Website" />
          <img src={youtube} alt="Youtube" />
        </div>
      </div>
      <div className="wrapper-logo-mobile">
        <div
          className="logo"
          onClick={() => setCurrentPage(1)}
          onTouchStart={() => setCurrentPage(1)}
        >
          <img src={logo} alt="Logo" />
        </div>
        <div className="wrapper-logo-mobile-left">
          {isInstallVisible && (
            <div className="android-apple">
              <img
                src={apple}
                alt="Install on iOS"
                onClick={isIOS ? handleInstallClick : null}
                className={isIOS ? "glow" : ""}
              />
              <img
                src={android}
                alt="Install on Android"
                onClick={isAndroid ? handleInstallClick : null}
                className={isAndroid ? "glow" : ""}
              />
            </div>
          )}
          <div className="youtube-link">
            <img src={rectangularPlay} alt="Rectangle YT" />
            <img src={www} alt="Website" />
            <img src={youtube} alt="Youtube" />
          </div>
        </div>
      </div>
    </>
  );
};

export default LogoPage;
